import { createStore } from 'react-context-toolkit'
import priceCalculatorSlice from './context/price-calculator.slice'
 
export const {
  useSelector,
  useDispatch,
  StateProvider,
  initialState,
} = createStore([priceCalculatorSlice])